import { render, staticRenderFns } from "./BankSettings.vue?vue&type=template&id=0677b5a4&scoped=true"
import script from "./BankSettings.vue?vue&type=script&lang=js"
export * from "./BankSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0677b5a4",
  null
  
)

export default component.exports